import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
// Resources
import { breakpoints } from '@/css/resources/variables.css';
import { fluidValues } from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	cssObj({
		[`@media (max-width: calc(${breakpoints.tablet} - 1px))`]: fluidValues(
			'marginBottom',
			styles?.margin?.bottom?.[0],
			styles?.margin?.bottom?.[1]
		),
	});
const getStyles = (styles) =>
	css(getDynamicStyles(styles), {
		position: 'relative',
		width: '100%' /* to prevent big images from stretching the grid */,

		[`@media (max-width: calc(${breakpoints.tablet} - 1px))`]: {
			maxWidth: '400px',
		},

		[`@media (min-width: ${breakpoints.laptop})`]: {
			marginTop: 0,
		},

		'.supt-media__image': {
			width: '100%',
			maxWidth: '100%',

			'&:first-child': {
				position: 'relative',
				[`@media (max-width: calc(${breakpoints.tablet} - 1px))`]: {
					opacity: '1 !important',
				},
			},

			'&:not(:first-child)': {
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				opacity: 0,

				[`@media (max-width: calc(${breakpoints.tablet} - 1px))`]: {
					opacity: '0 !important',
				},
			},
		},

		'.supt-media__motionImagesWrapper': {
			display: 'block',
			position: 'sticky',
			top: '80px',
		},

		'&.is-sticky': {
			[`@media (min-width: ${breakpoints.tablet})`]: {
				position: 'sticky',
				top: '80px',
				/* For sticky to work */
				alignSelf: 'baseline',
			},
		},
	});

export { getStyles };
